import { render, staticRenderFns } from "./filter-new-text.vue?vue&type=template&id=80426052&"
import script from "./filter-new-text.vue?vue&type=script&lang=js&"
export * from "./filter-new-text.vue?vue&type=script&lang=js&"
import style0 from "./filter-new-text.vue?vue&type=style&index=0&id=80426052&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80426052')) {
      api.createRecord('80426052', component.options)
    } else {
      api.reload('80426052', component.options)
    }
    module.hot.accept("./filter-new-text.vue?vue&type=template&id=80426052&", function () {
      api.rerender('80426052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/filter-components/filter-new-text.vue"
export default component.exports